// extracted by mini-css-extract-plugin
export default {"card1":"AudioDetail_card1__Mf9fs","card-title":"AudioDetail_card-title__YzJad","icon":"AudioDetail_icon__w22Hv","Audio":"AudioDetail_Audio__xO36c"};